<template>
  <div class="task-page">
    <task-single :company="companyId"></task-single>
  </div>
</template>

<script>
  import TaskSingle from '../tasks/includes/TaskSingle'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'task',
    data () {
      return {
        companyId: null
      }
    },
    computed: {
      ...mapGetters([])
    },
    methods: {
      ...mapActions([])
    },
    components: {
      TaskSingle
    },
    created () {
      this.companyId = parseInt(this.$route.params.companyId)
    },
    watch: {
      '$route' (to, from) {
        if (to.params.companyId !== from.params.companyId) {
          this.companyId = parseInt(to.params.companyId)
        }
      }
    }
  }
</script>

<style src="@/assets/scss/components/task-root.scss" lang="scss" />



// WEBPACK FOOTER //
// Task.vue?191bb2e2